import React from "react"
import {CatalogPage, CatalogPageProps} from "./CatalogPage"
import {useParams} from "react-router-dom"
import {Custom} from "../Custom"
import {HttpService} from "../../service/HttpService"
import {AuthService} from "../../service/AuthService";
import {CatalogType} from "../../type/catalogTypes";


export const CatalogPageContainer: React.FC<CatalogPageProps> = props => {

  const {initiativeLogicId} = useParams()
  const customProject = HttpService?.customProject
  const type = props?.type === CatalogType.digitalWallet ? 'digital-wallet' : 'loyalty-collection'

  return <>
        {
          customProject?.customFrontend &&
          customProject?.frontendComponents?.some(component => (component?.pathUrl === `/public/catalog/${type}-custom` && !AuthService.authorized) || component?.pathUrl === `/catalog/${type}-custom`)
            ? <Custom customFrontendUrl={customProject?.customFrontendUrl}
                      type={customProject?.frontendComponents?.find(comp =>
                          ((comp?.pathUrl === `/public/catalog/${type}-custom` && !AuthService.authorized) || comp?.pathUrl === `/catalog/${type}-custom`)
                      )?.component}
            />
            :
            <CatalogPage {...props} key={initiativeLogicId} />
        }
  </>
}
